import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { LinkSize } from '@dreryk/react-components';

import {
   MedicalImagingDetailsModalOpener as MedicalImagingModalOpener,
   MedicalInformationModalOpenLink,
} from '~legacy.patient';

type MedicalImagingDetailsModalOpenerProps = {
   readonly medicalImaging: MedicalImaging;
};

export const MedicalImagingDetailsModalOpener = (props: MedicalImagingDetailsModalOpenerProps): JSX.Element => {
   return (
      <MedicalImagingModalOpener medicalImaging={props.medicalImaging}>
         {({ openModal }) => (
            <MedicalInformationModalOpenLink onClick={openModal} unsignedAttachmentCount={0} size={LinkSize.NORMAL} />
         )}
      </MedicalImagingModalOpener>
   );
};
